import React, { useState, useEffect } from 'react';
import logo from './vdc_logo.png';
import { useNavigate } from 'react-router-dom'; // to navigate after logout
import { BASE_URL } from "./Constants.js";
import useAuth from './useAuth';

const Header = ({onToggleSidebar, isSidebarOpen}) => {
  useAuth();
  const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(false);
  const [user, setUser] = useState(null); // State to store user profile data
  const [loading, setLoading] = useState(true); // Loading state to show loading message or spinner
  const [error, setError] = useState(null); // Error state for handling API failures
  const navigate = useNavigate(); // React Router hook to handle navigation

  // Fetch user profile on component mount
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    console.log(token); // for debugging
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        

        const data = await response.json();
        setUser(data); // Assuming the response contains the user profile info
      } catch (error) {
        setError(error.message); // Handle errors
        console.error('Error fetching profile:', error);
      } finally {
        setLoading(false); // Set loading to false after data fetch completes
      }
    };

    const checkTokenExpiration = () => {
      const exp = localStorage.getItem('exp');
      if (exp && Date.now() > exp) {
          handleLogout();
      } else {
          const timeoutDuration = exp - Date.now();
          if (timeoutDuration > 0) {
              setTimeout(() => {
                  handleLogout();
              }, timeoutDuration);
          }
      }
  };

  fetchProfile();
  checkTokenExpiration();
  }, []); // Empty dependency array ensures this runs only once when the component mounts

  const toggleAccountDropdown = (e) => {
    e.preventDefault();
    setIsAccountDropdownOpen((prevState) => !prevState);
  };

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('authToken');
      // Make API call to the logout endpoint
      const response = await fetch(`${BASE_URL}logout`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`, // Assuming token is stored in localStorage
          'Content-Type': 'application/json',
        },
      });

      // Handle response
      const data = await response.json();
      if (response.ok) {
        // Clear any authentication tokens or session data
        localStorage.removeItem('authToken'); // Remove token from localStorage
        sessionStorage.removeItem('user'); // Optionally clear other session data

        // Navigate to login page or home page after successful logout
        navigate('/'); // You can change this to wherever you want to redirect
      } else {
        // Handle error (invalid token or any other issue)
        console.error('Logout failed:', data.message);
      }
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  if (loading) {
    return <div>Loading...</div>; // Show loading message while the profile data is being fetched
  }

  if (error) {
    return <div>Error: {error}</div>; // Show error message if the fetch fails
  }

  return (
    <header
  className="header-desktop"
  style={{
    background: '#fff',
    zIndex: 531,
    width: '100%',
    position: 'fixed', // <-- make it fixed to the top
    top: 0,
    left: 0,
    right: 0,
    height: '80px', // or whatever height you want
    boxShadow: '0px 1px 4px rgba(0,0,0,0.1)', // optional: visual separation
  }}
>
     <div
  className="section__content section__content--p30"
  style={{
    paddingLeft: isSidebarOpen && window.innerWidth >= 992 ? '0px' : '0',
    transition: 'padding-left 0.3s ease',
  }}
>
  <div className="container-fluid">
          <div className="header-wrap">
          <button className="btn btn-outline-secondary d-none d-lg-inline-block me-3" style = {{marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '100px',
            transition: 'margin-left 0.3s ease',}} onClick={onToggleSidebar}>
  ☰
</button>
            <form className="form-header" action="" method="POST"></form>
            <div className="header-button">
              <div className="noti-wrap">
                {/* Notification section */}
              </div>

              {/* User profile */}
              <div className="account-wrap">
                <div className="account-item clearfix js-item-menu">
                  <div className="image">
                    <img src={logo} alt="John Doe" />
                    
                  </div>
                  <div className="content">
                    {/* Show emp_code if the user is available */}
                    {user && user.profile && user.profile.emp_code ? (
                      <div>
                        <span className="user-id">{user.profile.emp_code}</span> {/* Display emp_code */}
                        <a href="#" onClick={handleLogout}>
                          <i className="zmdi zmdi-power"></i>Logout
                        </a>
                      </div>
                    ) : (
                      <a href="#" onClick={handleLogout}>
                        <i className="zmdi zmdi-power"></i>Logout
                      </a>
                    )}
                  </div>

                  {/* Account dropdown */}
                  <div
                    className={`account-dropdown js-dropdown ${isAccountDropdownOpen ? 'show' : ''}`}
                  >
                    <div className="info clearfix">
                      <div className="image">
                        <a href="#">
                         {/*<img src={logo} alt="John Doe" />*/}
                    <img src="images/logo.jpg" alt="VDC" />
                        </a>
                      </div>
                      <div className="content">
                        <h5 className="name">
                          <a href="#">john doe</a>
                        </h5>
                        <span className="email">johndoe@example.com</span>
                      </div>
                    </div>
                    <div className="account-dropdown__footer">
                      <a href="#" onClick={handleLogout}>
                        <i className="zmdi zmdi-power"></i>Logout
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
